import { ButtonHTMLAttributes, CSSProperties, FC, ReactNode } from 'react'
import classes from './index.module.css'
import cn from 'classnames'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
  color?: 'primary' | 'secondary' | 'gray' | 'dark-gray' | 'white'
  // variant?: ""...;
  rightContent?: ReactNode
  leftContent?: ReactNode
  isLoading?: boolean
}

const Button: FC<ButtonProps> = ({
  color,
  rightContent,
  leftContent,
  children,
  className,
  isLoading,
  style,
  ...props
}) => {
  const styleVar = {
    textColor: '#ffffff',
    backgroundColor: '#9747ff',
    spinColor: '#ffffff',
  }

  switch (color) {
    case 'primary':
      styleVar.textColor = '#ffffff'
      styleVar.backgroundColor = '#9747ff'
      styleVar.spinColor = '#ffffff'
      break

    case 'secondary':
      styleVar.textColor = '#000000'
      styleVar.backgroundColor = '#F9EDFF'
      styleVar.spinColor = '#9747ff'
      break

    case 'gray':
      styleVar.textColor = '#000000'
      styleVar.backgroundColor = '#F4F2F2'
      styleVar.spinColor = '#9747ff'
      break

    case 'dark-gray':
      styleVar.textColor = '#ffffff'
      styleVar.backgroundColor = '#A3A3A5'
      styleVar.spinColor = '#ffffff'
      break

    case 'white':
      styleVar.textColor = '#000000'
      styleVar.backgroundColor = '#FFFFFF'
      styleVar.spinColor = '#9747ff'
      break

    default:
      break
  }

  return (
    <button
      type="button"
      className={cn(classes.button, className)}
      style={{
        backgroundColor: styleVar.backgroundColor,
        color: styleVar.textColor,
        ...style,
      }}
      {...props}
    >
      <>
        {leftContent && <div>{leftContent}</div>}
        {isLoading && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
                style={{ color: styleVar.spinColor }}
              />
            }
            size="small"
            className={classes.loadingIcon}
          />
        )}
        {children}
        {rightContent && <div>{rightContent}</div>}
      </>
    </button>
  )
}

export default Button
